<div class="alberta-button-listitem-generalWrapper">
  <div class="alberta-button-listitem-wrapper">
    <div class="alberta-button-listitem-content">
      <div class="alberta-button-listitem-warnings">
        <itl-info-box *ngIf="isInAbo" [type]="infoBoxInAbo">{{ 'order.edit.isInAbo' | translate }}</itl-info-box>
        <itl-info-box *ngIf="articleNotAvailable" [type]="infoBoxTypeWarning">{{
          'validation.errors.articleNotOrderable' | translate
        }}</itl-info-box>
        <itl-info-box *ngIf="maxQuantityReached" [type]="infoBoxTypeWarning">{{
          'validation.errors.maxAmountExceeded' | translate
        }}</itl-info-box>
        <itl-info-box *ngIf="articleNotFoundInCareproposal" [type]="infoBoxTypeWarning">{{
          'validation.warning.articleNotFoundInCareproposal' | translate
        }}</itl-info-box>
        <itl-info-box *ngIf="articleIsDelayed" [type]="infoBoxTypeInformation">
          {{ 'validation.warning.articleIsDelayed' | translate }} {{ delayedTo }}
        </itl-info-box>
        <itl-info-box *ngIf="isNew" [type]="infoBoxSuccess" [icon]="'alberta-new'">{{
          'order.edit.isNew' | translate
        }}</itl-info-box>
      </div>

      <div class="alberta-button-listitem-article">
        <ng-content select="itl-integratedcare-article"></ng-content>
      </div>
    </div>
    <ng-content select="itl-single-order-article-list-item-button"></ng-content>
  </div>
  <div class="alberta-button-listitem-borderWrapper">
    <div class="alberta-button-listitem-borderTumbnailSpacer"></div>
    <div class="alberta-button-listitem-border"></div>
  </div>
</div>
